AuthRoute = require 'mixins/authenticated-route'

###
# Меню со всеми блюдами и категориями
###
App.CategoryRoute = Em.Route.extend AuthRoute,

  model: (params) ->
    Ember.RSVP.hash
      model: @store.find('draft_category', params.category_id)
      modifierGroups: @store.find 'modifier_group'
      dishGroups: @store.find 'dish_group'
      cooking_lines: @store.find 'cooking_line'
      dishes: @store.filter 'draft_dish', {draft_category_id: params.category_id}, (dish) ->
        dish.get('draft_category.id') is params.category_id

  setupController: (controller, hash) ->
    controller.setProperties hash

